export enum ConditionType {
    SICKNESS = 'Sickness',
    INJURY = 'Injury',
    PREGNANCY = 'Pregnancy'
}